import { get, writable } from 'svelte/store';
import { getCallTime, compareCallTime } from '../callQueue';

export const explorationModes = ["initial", "exploration", "more-like-this"];
export const explorationKeys = {
  INITIAL: "initial",
  EXPLORATION: "exploration",
  MORELIKETHIS: "more-like-this"
}
export const explorationMode = writable();
export const explorationTarget = writable();
export const explorationStorage = writable({});
export const mltStorage = writable({});
export const forceRefrechRecs = writable(false);
export function setExplorationMode(m, uid) {
  if (explorationModes.includes(m)) {
    explorationMode.set(m);
    explorationTarget.set(uid);
  } else {
    explorationMode.set(undefined);
    explorationTarget.set(undefined);
  }
}
export function clearExplorationMode(c) {
  // console.log(c)
  explorationMode.set(undefined);
  explorationTarget.set(undefined);
}
export const underHypothesis = writable(false);

export function updateExplorationStorage(source_uid, target_uid, data, output_config) {
  explorationStorage.update((store) => {
    store[target_uid] = {
      source_uid,
      data,
      called: getCallTime(),
      output_config
    }
    return store;
  });
}
export function loadExplorationStorage(source_uid, target_uid, source_last_update) {
  let data = get(explorationStorage)[target_uid];
  if (data?.source_uid === source_uid && compareCallTime(source_last_update, data?.called) < 0) {
    return data;
  } else {
    return null;
  }
}
export function updateMLTStorage(source_uid, target_uid, data, output_config) {
  mltStorage.update((store) => {
    store[target_uid] = {
      source_uid,
      data,
      called: getCallTime(),
      output_config
    }
    return store;
  });
}
export function loadMLTStorage(source_uid, target_uid, source_last_update) {
  let data = get(mltStorage)[target_uid];
  if (data?.source_uid === source_uid && compareCallTime(source_last_update, data?.called) < 0) {
    return data;
  } else {
    return null;
  }
}